import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';

import { auth } from './firebase';
import App from './App';
import Index from './pages/Index';
import Login from './pages/Login';
import Create from './pages/Create';
import Show from './pages/Show';

Vue.use(VueRouter);
Vue.use(VueMaterial);

Vue.config.productionTip = false;

const state = {
  auth: {
    user: null,
    initialized: false,
    waitPromise: null,
    resolvePromise: null,
  },
  setUser(user) {
    this.user = user;
    this.initialized = true;
    if (this.resolvePromise) {
      this.resolvePromise(this.user);
    }
  },
  waitForUser() {
    if (this.initialized) {
      return Promise.resolve(this.user);
    }
    this.waitPromise = this.waitPromise || new Promise(resolve => {
      this.resolvePromise = resolve;
    });
    return this.waitPromise;
  },
};

auth().onAuthStateChanged(user => {
  state.setUser(user);
});

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index,
    },
    {
      path: '/login',
      component: Login,
      props: r => ({ nextUrl: r.query.nextUrl }),
      beforeEnter: (to, from, next) => state.waitForUser().then(user => {
        if (user && to.query.nextUrl) {
          next({ path: to.query.nextUrl });
        } else if (user) {
          next({ path: '/' });
        } else {
          next();
        }
      }),
    },
    {
      path: '/create',
      component: Create,
      props: r => ({ url: r.query.url }),
      beforeEnter: (to, from, next) => state.waitForUser().then(user => {
        if (!user) {
          next({ path: '/login', query: { nextUrl: to.fullPath } });
        } else {
          next();
        }
      }),
    },
    {
      path: '/:id',
      component: Show,
      props: route => ({ showingId: `-${route.params.id}` }),
      beforeEnter: (to, from, next) => state.waitForUser().then(user => {
        if (!user) {
          next({ path: '/login', query: { nextUrl: to.fullPath } });
        } else {
          next();
        }
      }),
    },
  ],
});

new Vue({
  render: h => h(App),
  router,
  data: state,
}).$mount('#app');
